module.exports = __webpack_public_path__ + "static/media/rotate-phone.3f221ab9.gif";